<template>
    <div>
        <div v-for="yItem, i in input_data.y_items" :key="i">
            <div class="y_axis_separation" ></div>
                <el-form-item label-width="0" v-if="input_data.y_items.length > 1" style="display: flex; justify-content: flex-end;" class="remove-y-item-wrapper">
                    <a 
                        @click="removeYItem(i)" 
                        class="btn btn-danger text-white remove-y-item"  
                        v-html="'x'"
                        style="width: 34px; height: 34px; display: inline-flex; align-items: center; justify-content: center;" 
                    >
                    </a>
                </el-form-item>
                <el-form-item label-width="0" >

                    <FormInputTextCol 
                        v-model="input_data.y_items[i].label_name" 
                        :showOn="true"
                        :label="$t('input_table.y_axis_label_name')" 
                        placeholder="ラベル名を入力"
                        classes="y_axis item-left" 
                        :maxlength="constants.INPUT_LIMIT.TEXT_MAX_LENGTH"
                        :required="true"
                        :error="getError(i,'label_name')"
                    />

                    <FormInputSelectCol 
                        v-model="yItem.input_method" 
                        :field="yItem"
                        :showOn="true" 
                        :required="true"
                        :options="inputMethodsData()"
                        classes="y_axis item-center" 
                        @change="onInputMethodChange(yItem, i)"
                        :label="$t('input_table.y_axis_input_method')" 
                        :error="getError(i,'input_method')"
                    />

                    <FormInputSelectCol 
                        v-model="input_data.y_items[i].check_method" 
                        :field="yItem"
                        :showOn="true"
                        :options="checkMethodData(yItem)" 
                        :multiple="true" 
                        classes="y_axis item-left"
                        @change="onCheckMethodChange(i)"
                        :label="$t('input_table.y_axis_input_check')" 
                    />

                    <FormInputTextCol 
                        v-model="input_data.y_items[i].display_order" 
                        :showOn="true"
                        type="number"
                        :label="$t('input_table.y_axis_display_order')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'display_order')"
                    />

                    <FormInputSelectCol 
                        v-model="input_data.y_items[i].item_role" 
                        :field="yItem"
                        :showOn="true"
                        :disabled="isItemRoleDisabled()"
                        :options="itemRoleData(yItem)" 
                        classes="y_axis item-left"
                        :label="'項目権限'" 
                    />

                    <FormInputTextCol 
                        v-if="input_methods.isShowSelections(yItem)"
                        v-model="input_data.y_items[i].selections"
                        :showOn="input_methods.isShowSelections(yItem)"
                        :label="$t('input_table.y_axis_selections')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'selections')"
                    />

                    <FormInputTextarea v-if="input_methods.isShowDisplayContent(yItem)"
                        v-model="input_data.y_items[i].display_content"
                        :label="$t('input_table.y_axis_display_content')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'display_content')"
                    />

                    <FormInput2RangeCol 
                        v-if="check_methods.isShowSizeRange(yItem)" 
                        label="軸容量"
                        :modelValue1="input_data.y_items[i].range_from_size"
                        :modelValue2="input_data.y_items[i].range_to_size"
                        @update:modelValue1="input_data.y_items[i].range_from_size = $event"
                        @update:modelValue2="input_data.y_items[i].range_to_size = $event" 
                        :error="getError(i,'range_from_size|range_to_size')"
                    />

                    <FormInputTextCol 
                        :showOn="check_methods.isShowAcceptableExtensions(yItem)" 
                        v-model="input_data.y_items[i].acceptable_extensions" 
                        label="軸許可拡張"
                        classes="y_axis item-left" 
                        maxlength="100"
                        :error="getError(i,'acceptable_extensions')"
                    />

                    <FormInputAttachmentCol :label="$t('input_table.y_axis_attachments')"
                        :showOn="input_methods.isShowAttachment(yItem)" 
                        :modelPath="input_data.y_items[i].item_file_path"
                        :modelUrl="input_data.y_items[i].url_download_file"
                        :field="field"
                        :yCoordinate="input_data.y_items[i].field_key"
                        @update:modelPath="input_data.y_items[i].item_file_path = $event"
                        @update:modelUrl="input_data.y_items[i].url_download_file = $event" 
                        @remove-file="$emit('remove-file', $event)"
                        :error="getError(i,'item_file_path')"
                        classes="y_axis item-center" 
                    />

                    <FormInput2RangeCol v-if="check_methods.isShowDigitRange(yItem)" label="軸桁数"
                        :modelValue1="input_data.y_items[i].range_from_digit"
                        :modelValue2="input_data.y_items[i].range_to_digit"
                        @update:modelValue1="input_data.y_items[i].range_from_digit = $event"
                        @update:modelValue2="input_data.y_items[i].range_to_digit = $event" 
                        :error="getError(i,'range_from_digit')"
                    />

                    <FormInputCalcMatchCol v-if="input_methods.isShowCalculation(yItem)"
                        :error="errors[i] ? errors[i][0] : null "
                        :tableFieldData="input_data"
                        :field="input_data.y_items[i]"
                        :calc_item="input_data.y_items[i].calc_item" 
                        :calc_method="input_data.y_items[i].calc_method"
                        :number_calc="input_data.y_items[i].number_calc" 
                        :calculation="input_data.y_items[i].calculation" 
                        @update:calc_item="input_data.y_items[i].calc_item = $event"
                        @update:calc_method="input_data.y_items[i].calc_method = $event" 
                        @update:number_calc="input_data.y_items[i].number_calc = $event" 
                        @update:calculation="input_data.y_items[i].calculation = $event" 
                    />

                    <FormInputTextCol v-if="input_methods.isShowCalculation(yItem)" label="小数点の桁数"
                        classes="y_axis item-center">
                        <el-input class="bg-gray-item" v-model="input_data.y_items[i].number_decimal"
                            @input="validNumber($event, form[formindex])" />
                    </FormInputTextCol>

                    <FormInputSelectCol v-if="input_methods.isShowCalculation(yItem)" 
                        v-model="input_data.y_items[i].rounding_type"
                        :options="constants.ROUNDING_CALCULATION" 
                        classes="y_axis item-center" 
                        label="丸めルール"
                    />

                </el-form-item>
                <TableCopyYAxisField
                    v-model="input_data.y_items[i].copy_y_key_ref"
                    :y-item="yItem"
                    :form-base="form_base"
                    :field="field"
                    :copy-error="getError(i, 'copy_y_key_ref')"
                />
                 <!-- 親フォームValidate section -->
                 <el-form-item prop="parent" label-width="0px" v-if="validationFormBaseList && validationFormBaseList.length > 0 && isAllowedInputMethodForValidation(yItem)">
                        <div v-for="(operator, operatorIndex) in input_data.y_items[i].validation_operator" :key="operatorIndex" class="mb-3">
                            <el-row :gutter="20">
                                <!-- Col 1 -->
                                <el-col :md="6">
                                    <el-form-item class="item-fome-base y_axis item-left" label="親フォームValidate" prop="parent_form_validate">
                                        <el-select 
                                            class="w--10 bg-gray-item"
                                            v-model="input_data.y_items[i].validation_form_id"
                                            :disabled="operatorIndex !== 0"
                                            placeholder="選択してください"
                                            @change="onValidationFormChange(i, input_data.y_items[i])">
                                            <el-option label="なし" :value="null"></el-option>
                                            <!-- nếu đã có "master" (Y được chọn validate đầu tiên) thì Y khác chỉ được chọn null hoặc giá trị master -->
                                            <template v-if="isMasterValidationRow(i) || !getSelectedValidationFormId()">
                                                <el-option v-if="form_base.kaiso_flg == 1 && form_base.approval_id !== null"
                                                label="生成先フォーム" :value="constants.PARENT_FORM_VALIDATE.HIERARCHY"></el-option>
                                                <el-option
                                                    v-for="(item, index) in validationFormBaseList"
                                                    :key="index"
                                                    :label="item.form_name"
                                                    :value="item.form_id">
                                                </el-option>
                                            </template>
                                            <el-option
                                                v-else
                                                :label="getSelectedValidationFormLabel()"
                                                :value="getSelectedValidationFormId()"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <!-- Col 2 -->
                                <el-col :md="6">
                                    <el-form-item class="item-fome-base y_axis item-left mb-2" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id">
                                        <el-select 
                                            class="w--10 bg-gray-item"
                                            v-model="input_data.y_items[i].validation_item_id"
                                            :disabled="
                                                operatorIndex !== 0 ||
                                                input_data.y_items[i].validation_form_id === constants.PARENT_FORM_VALIDATE.HIERARCHY ||
                                                (!isMasterValidationRow(i) && getSelectedValidationItemId() !== null)
                                            "
                                            placeholder="選択してください"
                                            @change="onValidationItemChange(i, operatorIndex)">
                                            <el-option label="なし" :value="null"></el-option>
                                            <el-option
                                                v-if="input_data.y_items[i].validation_form_id === constants.PARENT_FORM_VALIDATE.HIERARCHY"
                                                label="該当項目"
                                                :value="constants.PARENT_FORM_VALIDATE.AUTO"
                                                disabled>
                                            </el-option>
                                            <el-option
                                                v-for="(item, index) in getFormItemsForValidation(i)"
                                                :key="index"
                                                :label="item.label_name"
                                                :value="item.item_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item class="item-fome-base y_axis item-left mb-2" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-select 
                                            v-if="input_data.y_items[i].validation_form_id !== constants.PARENT_FORM_VALIDATE.HIERARCHY"
                                            class="w--10 bg-gray-item"
                                            v-model="operator.y_key_ref"
                                            placeholder="選択してください">
                                            <el-option label="なし" :value="null"></el-option>
                                            <el-option
                                                v-for="(yItem, yIndex) in getValidationTableYItems(i)"
                                                :key="yIndex"
                                                :label="yItem.label_name"
                                                :value="yItem.field_key">
                                            </el-option>
                                        </el-select>
                                        <el-select 
                                            v-else
                                            disabled
                                            class="w--10 bg-gray-item"
                                            :value="constants.PARENT_FORM_VALIDATE.AUTO"
                                            placeholder="選択してください">
                                            <el-option label="該当項目" :value="constants.PARENT_FORM_VALIDATE.AUTO"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item class="item-fome-base y_axis item-center" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-select 
                                            v-if="input_data.y_items[i].validation_form_id !== constants.PARENT_FORM_VALIDATE.HIERARCHY"
                                            class="w--10 bg-gray-item"
                                            v-model="operator.x_key_ref"
                                            placeholder="選択してください">
                                            <el-option label="なし" :value="null"></el-option>
                                            <el-option
                                                v-for="(xItem, xIndex) in getValidationTableXItems(i)"
                                                :key="xIndex"
                                                :label="xItem.label_name"
                                                :value="xItem.field_key">
                                            </el-option>
                                        </el-select>
                                        <el-select 
                                            v-else
                                            disabled
                                            class="w--10 bg-gray-item"
                                            :value="constants.PARENT_FORM_VALIDATE.AUTO"
                                            placeholder="選択してください">
                                            <el-option label="該当項目" :value="constants.PARENT_FORM_VALIDATE.AUTO"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <!-- Col 3 -->
                                <el-col :md="6">
                                    <el-form-item class="item-fome-base y_axis item-center" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-select 
                                            class="w--10 bg-gray-item"
                                            v-model="operator.operator"
                                            placeholder="選択してください">
                                            <el-option label="なし" value=""></el-option>
                                            <el-option
                                                v-for="(item, index) in getValidationOperators(yItem)"
                                                :key="index"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <!-- Col 4 -->
                                <el-col :md="4">
                                    <el-form-item class="item-fome-base y_axis item-left mb-2" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-input 
                                            :disabled="true"
                                            class="bg-gray-item"
                                            :value="field ? field.label_name : ''"
                                            placeholder="ラベル名">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item class="item-fome-base y_axis item-center mb-2" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-input 
                                            :disabled="true"
                                            class="bg-gray-item"
                                            :value="input_data.y_items[i].label_name"
                                            placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item class="item-fome-base y_axis item-left" label="" prop="parent_form_validate" v-if="input_data.y_items[i].validation_form_id && input_data.y_items[i].validation_item_id">
                                        <el-select 
                                            class="w--10 bg-gray-item"
                                            v-model="operator.x_key"
                                            :disabled="!hasXItemWithLabelName()"
                                            placeholder="選択してください">
                                            <el-option label="なし" :value="null"></el-option>
                                            <el-option
                                                v-for="(xItem, xIndex) in input_data.x_items"
                                                :key="xIndex"
                                                :label="xItem.label_name"
                                                :value="xItem.field_key"
												:disabled="checkXKeyDuplicate(i, operatorIndex, xItem.field_key)"
											>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <!-- Col 5 -->
                                <el-col :md="2" v-if="input_data.y_items[i].validation_operator.length > 1">
                                    <el-form-item class="item-fome-base y_axis item-center" prop="parent_form_validate">
                                        <a 
                                            @click="removeValidationOperator(i, operatorIndex)"
                                            class="btn btn-danger text-white remove-y-item"  
                                            v-html="'x'"
                                            style="width: 34px; height: 34px; display: inline-flex; align-items: center; justify-content: center;" 
                                        >
                                        </a>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <label 
                                v-if="getTableValidationError(i, operatorIndex)"
                                class="text-danger text-left">
                                {{ getTableValidationError(i, operatorIndex) }}
                            </label>
                        </div>

                        <!-- Button thêm validation row -->
                        <el-row :gutter="20" v-if="input_data.y_items[i].validation_form_id">
                            <el-col :md="6">
                                <el-form-item prop="parent_form_validate" class="text-left">
                                    <button type="button" @click="addValidationOperator(i)" class="btn btn-primary" style="background-color: #00aff0;">
                                        <i class="flaticon2-plus-1" /> 親フォームValidate設定追加
                                    </button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form-item>
            </div>
            

        <el-form-item label-width="0" class="table-coordinates">
            <div class="axis_plus mb-16">
                <button type="button" @click="addYItem" class="btn" :disabled="input_data.y_items.length >= 100" >
                    <i class="flaticon2-plus-1" /> <strong>Y</strong> 追加
                </button>
            </div>
            <el-col :md="24" class="x_items">
                <el-col :md="14" v-for="xItem, i in input_data.x_items" :key="i">
                    <el-form-item class="item-fome-base x_axis item-left" :label="$t('input_table.y_axis_label_name')">
                        <input v-model="xItem.label_name" type="text" autocomplete="off" class="el-input__inner" placeholder="X軸ラベル名" :maxlength="input_limit.TEXT_MAX_LENGTH" required />
                        <a @click="removeXItem(i)" v-if="input_data.x_items.length > 1" class="btn btn-danger text-white remove-x-column" v-html="'x'" />
                        
                    </el-form-item>

                    <el-form-item class="item-fome-base item-error">
                        <label class="el-form-item__label" style="min-width: 200px;"></label>
                        <div class="el-form-item__content text-danger" v-if="getError(i,'label_name', 'x_items')">{{ getError(i,'label_name', 'x_items').msg }}</div>
                    </el-form-item>
                    
                </el-col>
                <el-col :md="24" class="axis_plus" >
                    <button type="button" @click="addXItem" class="btn" :disabled="input_data.x_items.length >= 1000">
                        <i class="flaticon2-plus-1" /> <strong>X</strong> 追加
                    </button>
                </el-col>
            </el-col>
            <el-col :md="24">
                <el-form-item class="item-fome-base text-left">
                    <el-checkbox v-model="input_data.x_allow_add"></el-checkbox>
                    <span class="input_table__label ml-3" v-html="$t('input_table.allow_add_x_axis')"></span>
                </el-form-item>
            </el-col>

        </el-form-item>
    </div>
</template>

<script>
import * as CheckMethods from "@/core/config/CheckMethods"
import * as constants from "@/core/config/constant"
import * as InputMethods from "@/core/config/InputMethods"
import FormInput2RangeCol from "@/view/components/inputs/FormItemCol/Input2Range"
import FormInputAttachmentCol from "@/view/components/inputs/FormItemCol/InputAttachment"
import FormInputCalcMatchCol from "@/view/components/inputs/FormItemCol/InputCalcMatch"
import FormInputSelectCol from "@/view/components/inputs/FormItemCol/InputSelect"
import FormInputTextCol from "@/view/components/inputs/FormItemCol/InputText"
import FormInputTextarea from "@/view/components/inputs/FormItemCol/InputTextarea"
import TableCopyYAxisField from "@/view/components/inputs/TableCopyYAxisField"

export default {
    components: {
        FormInputTextCol,
        FormInputSelectCol,
        FormInputTextarea,
        FormInput2RangeCol,
        FormInputCalcMatchCol,
        FormInputAttachmentCol,
        TableCopyYAxisField,
    },

    props: ['form_base','value', "errors", "field", "validationFormBaseList", "formIndex", "formItem"],
    data() {
        return {
            constants: constants,
            check_methods_opt: constants.CHECK_METHOD,
            input_limit : constants.INPUT_LIMIT,
            check_methods: CheckMethods,
            input_methods: InputMethods,
            // Master = trục Y được chọn 親フォームValidate đầu tiên (chỉ master mới điều khiển logic "ăn theo")
            validationMasterYIndex: null,
            // Giá trị 親フォームValidate của master (để UI follower hiển thị đúng 2 option: null + master)
            validationMasterFormId: null,
            // Giá trị validation_item_id của master (khi master đã chọn item thì các Y khác sẽ bị khóa theo)
            validationMasterItemId: null,
            input_data: {
                y_items: [],
                x_items:[],
                x_allow_add: false,
            },
            y_field: {
                field_key:'',
                label_name: '',
                check_method: [],
                input_method: null,
                display_order: constants.DISPLAY_ORDER_DEFUALT,
                selections: '',
                display_content: '',
                acceptable_extensions: '',
                item_file_path: '',
                url_download_file: '',
                range_from_size: '',
                range_to_size: '',

                range_from_digit: '',
                range_to_digit: '',
                number_decimal: '',
                calc_item: '',
                calc_method: '',
                number_calc: '',
                calculation: [],
                calc_flg: null,
                rounding_type: null,
                special_processing: '',
                item_role: constants.ITEM_ROLE_DEFAULT,
                item_role_list: constants.ITEM_ROLE,

                show_to_hide: false,
                hide_to_show: false,
                copy_y_key_ref: null,
                validation_form_id: null,
                validation_item_id: null,
                validation_operator: [
                    {
                        x_key_ref: null,
                        y_key_ref: null,
                        x_key: null,
                        y_key: null,
                        operator: null
                    }
                ],
            },
            x_field : {
                field_key: '',
		        label_name: '',
		        display_order: constants.DISPLAY_ORDER_DEFUALT
            },
            listValidationOperator: [
                { label: '=', value: 1 },
                { label: '≠', value: 2 },
                { label: '＜', value: 3 },
                { label: '＞', value: 4 },
                { label: '≦', value: 5 },
                { label: '≧', value: 6 }
            ],
        }
    },

    async mounted() {
        if (this.value && this.value.y_items) {
            await this.fillData()
        }

        if (this.input_data.y_items.length < 1) {
            this.addYItem()
        }

        if (this.input_data.x_items.length < 1) {
            this.addXItem()
        }
        this.input_data.y_items.forEach(yItem => {
            if (this.field.item_role === 2 || this.field.item_role === 3) {
                yItem.item_role = this.field.item_role
            }
        })

    },
    methods: {
        isMasterValidationRow(yItemIndex) {
            // Nếu chưa có master thì cho phép mọi Y hiển thị full option (cột Y nào được chọn lần đầu sẽ trở thành master)
            if (this.validationMasterYIndex === null || this.validationMasterYIndex === undefined) {
                return true;
            }
            return Number(yItemIndex) === Number(this.validationMasterYIndex);
        },
        getSelectedValidationFormId() {
            // Lấy giá trị master để giới hạn option trên các Y follower
            return this.validationMasterFormId ?? null;
        },
        getSelectedValidationItemId() {
            // Khi master đã chọn validation_item_id thì khóa tất cả Y khác theo giá trị này
            return this.validationMasterItemId ?? null;
        },
        getSelectedValidationFormLabel() {
            const selectedId = this.getSelectedValidationFormId();
            if (selectedId === null || selectedId === undefined) {
                return '';
            }
            if (selectedId === constants.PARENT_FORM_VALIDATE.HIERARCHY) {
                return '生成先フォーム';
            }
            const found = Array.isArray(this.validationFormBaseList)
                ? this.validationFormBaseList.find(f => f && f.form_id === selectedId)
                : null;
            return found?.form_name || String(selectedId);
        },
        resetValidationForYItem(yItem) {
            // Reset các field phụ thuộc vào validate (khi đổi form hoặc đổi item tham chiếu)
            if (!yItem) return;
            yItem.validation_item_id = null;
            yItem.validation_operator = [{
                x_key_ref: null,
                y_key_ref: null,
                x_key: null,
                y_key: yItem.validation_form_id ? (yItem.field_key || null) : null,
                operator: null
            }];
        },
        resetValidationOperatorsForYItem(yItem) {
            // Chỉ reset các field phụ thuộc validation_item_id không reset validation_form_id và validation_item_id
            if (!yItem) return;
            if (!yItem.validation_operator || !Array.isArray(yItem.validation_operator)) {
                yItem.validation_operator = [];
            }
            if (yItem.validation_operator.length === 0) {
                yItem.validation_operator.push({
                    x_key_ref: null,
                    y_key_ref: null,
                    x_key: null,
                    y_key: yItem.validation_form_id ? (yItem.field_key || null) : null,
                    operator: null
                });
            }
            yItem.validation_operator.forEach(operator => {
                operator.operator = null;
                operator.x_key_ref = null;
                operator.y_key_ref = null;
                operator.x_key = null;
                operator.y_key = yItem.validation_form_id ? (yItem.field_key || null) : null;
            });
        },
        fillData() {
            this.input_data.x_allow_add = this.value.x_allow_add
            const yItemsValue = []
            this.value.y_items.map((itemDB) => {
                const itemValue = {}
                Object.keys(this.y_field).map((k) => {
                    if (k === 'validation_operator' && itemDB[k]) {
                        // Parse validation_operator if it is string JSON
                        let parsedValidationOperator = itemDB[k];
                        if (parsedValidationOperator && typeof parsedValidationOperator === 'string') {
                            try {
                                parsedValidationOperator = JSON.parse(parsedValidationOperator);
                            } catch (e) {
                                parsedValidationOperator = null;
                            }
                        }
                        
                        // Ensure validation_operator is an array and create a deep copy so each yItem has its own
                        // Keep the entire array, not just the first element
                        if (Array.isArray(parsedValidationOperator) && parsedValidationOperator.length > 0) {
                            itemValue[k] = parsedValidationOperator.map(op => ({
                                x_key_ref: op.x_key_ref !== undefined ? op.x_key_ref : null,
                                y_key_ref: op.y_key_ref !== undefined ? op.y_key_ref : null,
                                x_key: op.x_key !== undefined ? op.x_key : null,
                                y_key: op.y_key !== undefined ? op.y_key : null,
                                operator: op.operator !== undefined ? op.operator : null
                            }));
                        } else {
                            itemValue[k] = [{
                                x_key_ref: null,
                                y_key_ref: null,
                                x_key: null,
                                y_key: null,
                                operator: null
                            }]
                        }
                    } else if (k === 'validation_operator' && !itemDB[k]) {
                        // If there is no validation_operator, create a new one
                        itemValue[k] = [{
                            x_key_ref: null,
                            y_key_ref: null,
                            x_key: null,
                            y_key: null,
                            operator: null
                        }]
                    } else {
                        itemValue[k] = itemDB[k] !== undefined && itemDB[k] !== null ? itemDB[k] : (this.y_field[k] !== undefined ? this.y_field[k] : null)
                    }
                })
                yItemsValue.push(itemValue)
            })
            this.input_data.y_items = yItemsValue
            this.input_data.x_items = this.value.x_items ? this.value.x_items : []
            // Khi load data từ api sẽ tự nhận diện master từ Y đầu tiên có validation_form_id
            const masterIndex = this.input_data.y_items.findIndex(y => y && y.validation_form_id !== null && y.validation_form_id !== undefined);
            if (masterIndex >= 0) {
                this.validationMasterYIndex = masterIndex;
                this.validationMasterFormId = this.input_data.y_items[masterIndex].validation_form_id;
                this.validationMasterItemId = this.input_data.y_items[masterIndex].validation_item_id ?? null;
            } else {
                this.validationMasterYIndex = null;
                this.validationMasterFormId = null;
                this.validationMasterItemId = null;
            }

        },
        
        addYItem() {
            if( this.input_data.y_items.length >= 100 ){
                return;
            }
            // Create a deep copy to ensure each yItem has its own validation_operator
            let cloneRow = JSON.parse(JSON.stringify(this.y_field))
            cloneRow.display_order = this.input_data.y_items.length + 1
            cloneRow.field_key = this.$uuid.v4()
            
            // Ensure validation_operator is a new array, not referencing y_field
            cloneRow.validation_operator = [{
                x_key_ref: null,
                y_key_ref: null,
                x_key: null,
                y_key: null,
                operator: null
            }]
            
            // Priority 1: Check field.item_role first (item_role = 2 or 3)
            if (this.field && (this.field.item_role === 2 || this.field.item_role === 3)) {
                cloneRow.item_role = this.field.item_role
            }
            // Priority 2: Check special_processing (special_processing = 3)
            else if( this.field && this.field.special_processing === 3 ){
                cloneRow.item_role = constants.ITEM_ROLE_KEY.ADMIN
            } 
            // Priority 3: Default to USER (item_role = 1)
            else {
                cloneRow.item_role = constants.ITEM_ROLE_KEY.USER
            }
            
            // Trục Y mới mặc định validate = null (không auto copy theo master)
            
            this.input_data.y_items.push(cloneRow)
        },

        addXItem() {
            if( this.input_data.x_items.length >= 1000 ){
                return;
            }
            let cloneColumn = Object.assign({}, this.x_field)
            cloneColumn.display_order = this.input_data.x_items.length + 1
            cloneColumn.field_key = this.$uuid.v4()
            this.input_data.x_items.push(cloneColumn)
        },
        inputMethodsData() {
            let methods = JSON.parse(JSON.stringify(constants.INPUT_METHOD))
            methods = methods.filter(obj => obj.value !== 10)
            if ([0].includes(this.form_base.special_item)) {
                methods.splice(8, 1)
            }
            return methods
        },
        inputMethodsChange(input) {
            input.check_method = [] // reset check method
        },
        onInputMethodChange(yItem, yItemIndex) {
            // Reset check method when input_method changes
            this.inputMethodsChange(yItem);
            
            // Clear validation operator when input_method changes
            this.clearValidationOperator(yItemIndex);

            if (yItem) {
                yItem.copy_y_key_ref = null;
            }
        },
        onCheckMethodChange(yItemIndex) {
            // Clear validation operator when check_method changes
            this.clearValidationOperator(yItemIndex);
        },
        clearValidationOperator(yItemIndex) {
            // Clear y_key_ref and x_key_ref when input_method or check_method changes
            const yItem = this.input_data.y_items[yItemIndex];
            if (yItem && yItem.validation_operator && yItem.validation_operator.length > 0) {
                yItem.validation_operator[0].y_key_ref = null;
                yItem.validation_operator[0].x_key_ref = null;
            }
        },
        isAllowedInputMethodForValidation(yItem) {
            // Only allow validation with the following input_methods
            const allowedInputMethods = [
                InputMethods.INPUT_METHOD_TEXT_SINGLE,
                InputMethods.INPUT_METHOD_TEXT_MULTI,
                InputMethods.INPUT_METHOD_SELECTION_SINGLE,
                InputMethods.INPUT_METHOD_SELECTION_MULTI,
                InputMethods.INPUT_METHOD_DATE,
                InputMethods.INPUT_METHOD_CALCULATION
            ];
            return yItem && yItem.input_method && allowedInputMethods.includes(yItem.input_method);
        },
        checkMethodData(input) {
            return CheckMethods.getCheckMethodOptions(input.input_method)
        },
        specialProcessingData(input) {
            return InputMethods.getSpecialProcessingOptions(input)
        },
        itemRoleData(input) {
            return constants.ITEM_ROLE
        },
        specialProcessingChange(input, index) {
            input.check_method=[];
            input.item_role_list = constants.ITEM_ROLE
            if (input.special_processing == constants.SPECIAL_PROCESSING[1].value){
                input.range_from_digit = constants.PASSWORD_LENGTH.min
                input.range_to_digit = constants.PASSWORD_LENGTH.max
                input.check_method=[1,4,8]
                input.item_role = constants.ITEM_ROLE_KEY.USER
            }else if (input.special_processing == constants.SPECIAL_PROCESSING[0].value){
                input.check_method=[1,7]
                input.item_role = constants.ITEM_ROLE_KEY.USER
                input.item_id_parent= {}
                input.copy_id =''
            } else if (input.special_processing == constants.SPECIAL_PROCESSING[3].value){
                input.check_method=[1,13]
                input.item_role = constants.ITEM_ROLE_KEY.USER
                input.item_id_parent= {}
                input.copy_id =''
            } else if (input.special_processing == constants.SPECIAL_PROCESSING[2].value){
                input.item_role = constants.ITEM_ROLE_KEY.ADMIN
            }
            else {
                input.range_from_digit = ''
                input.range_to_digit = ''
                input.item_role_list = constants.ITEM_ROLE_SPECIAL_PROCESSING_EMPTY
                input.item_role = constants.ITEM_ROLE_KEY.USER
            }
            
            if( index ){
                this.input_data.y_items[index].special_processing = input.special_processing
                this.input_data.y_items[index].item_role = input.item_role
                this.$emit('input', this.input_data)
            }
        },
        isItemRoleDisabled() {
            // Disable item_role when parent field has special_processing > 0
            return this.field && this.field.special_processing > 0
        },
        checkXKeyDuplicate(yIndex, operatorIndex, xKey) {
            const ops = this.input_data.y_items?.[yIndex]?.validation_operator || [];
            return ops.some((op, idx) => idx !== operatorIndex && op?.x_key === xKey);
        },
        updateItemRolesBasedOnSpecialProcessing() {
            // Update all Y items based on parent field's item_role or special_processing
            if (!this.field) return
            
            this.input_data.y_items.forEach(yItem => {
                // Priority 1: Check field.item_role first (item_role = 2 or 3)
                if (this.field.item_role === 2 || this.field.item_role === 3) {
                    yItem.item_role = this.field.item_role
                }
                // Priority 2: Check special_processing
                else if (this.field.special_processing === 3) {
                    yItem.item_role = constants.ITEM_ROLE_KEY.ADMIN
                }else {
                    // special_processing = 1, 2, 4
                    yItem.item_role = constants.ITEM_ROLE_KEY.USER   // = 1
                }
            })
        },
        checkEditItem() {
            return true
        },
        includeMethod(input, methodID) {
            return input.check_method.includes(methodID)
        },
        getError(i, field, itemType='y_items'){
            const fields = field.split('|')
            if( !this.errors[i] ){
                return null
            }
            console.log(`====== getError i=${i}`, this.errors, {itemType})

            const errors = this.errors[i].filter(er=>fields.indexOf(er.field)>-1 && er.coordinates===itemType)
            if( !errors ){
                return null
            }
            if( errors.length > 0){
                return errors[0]
            }
            return null
        },
        getValidationOperatorError(yItemIndex, operatorIndex, field) {
            // Get error for validation_operator with format: errors['validation_operator'][operatorIndex][field]
            if (!this.errors || !this.errors[field]) {
                return null;
            }
            
            const operatorErrors = this.errors[field][operatorIndex];
            if (!operatorErrors || !operatorErrors[field]) {
                return null;
            }
            return operatorErrors[field].msg || null;
        },
        onChangeXColumnHanlder(event){
        },
        removeXItem(index){
            if( this.input_data.x_items.length < 2 ){
                return
            }
            this.input_data.x_items.splice(index, 1)
        },
        removeYItem(index){
            if( this.input_data.y_items.length < 2 ){
                return
            }
            this.input_data.y_items.splice(index, 1)
        },
        onValidationFormChange(yItemIndex, inputData= null) {   
            const selectedVal = inputData ? inputData.validation_form_id : null
            const masterSet = this.validationMasterYIndex !== null && this.validationMasterYIndex !== undefined;
            const isMasterRow = masterSet ? (Number(yItemIndex) === Number(this.validationMasterYIndex)) : true;

            // Chưa có master: lần chọn khác null đầu tiên sẽ trở thành master
            if (!masterSet && selectedVal !== null && selectedVal !== undefined) {
                this.validationMasterYIndex = yItemIndex;
                this.validationMasterFormId = selectedVal;
                // Chọn form master lần đầu => item master chưa có
                this.validationMasterItemId = null;
            }

            // Khi đổi value ở trục Y khác mà không phải là master thì sẽ không được ảnh hưởng sang Y khác
            if (masterSet && !isMasterRow) {
                const yItem = this.input_data.y_items?.[yItemIndex];
                if (!yItem) return;

                if (selectedVal === null || selectedVal === undefined) {
                    // Follower chọn null => chỉ reset đúng follower
                    yItem.validation_form_id = null;
                    this.resetValidationForYItem(yItem);
                    this.$nextTick(() => this.$forceUpdate());
                    return;
                }

                // Follower chỉ được chọn null hoặc master => ép về master nếu user cố chọn form khác
                yItem.validation_form_id = this.validationMasterFormId;
                this.resetValidationForYItem(yItem);
                // Nếu master đã chọn item thì các trục Y khác cũng phải theo item đó
                if (this.validationMasterItemId !== null && this.validationMasterItemId !== undefined) {
                    yItem.validation_item_id = this.validationMasterItemId;
                }
                if (yItem.validation_form_id === constants.PARENT_FORM_VALIDATE.HIERARCHY) {
                    yItem.validation_item_id = constants.PARENT_FORM_VALIDATE.AUTO;
                }
                this.$nextTick(() => this.$forceUpdate());
                return;
            }

            // Khi master đổi value sẽ cập nhật master và reset các trục Y khác
            if (selectedVal === null || selectedVal === undefined) {
                this.validationMasterYIndex = null;
                this.validationMasterFormId = null;
                this.validationMasterItemId = null;

                const yItem = this.input_data.y_items?.[yItemIndex];
                if (yItem) {
                    yItem.validation_form_id = null;
                    this.resetValidationForYItem(yItem);
                }
                this.$nextTick(() => this.$forceUpdate());
                return;
            }

            // chỉ master có quyền chọn full option
            this.validationMasterYIndex = yItemIndex;
            this.validationMasterFormId = selectedVal;
            // Đổi form master => reset item master
            this.validationMasterItemId = null;

            const masterY = this.input_data.y_items?.[yItemIndex];
            if (masterY) {
                masterY.validation_form_id = selectedVal;
                this.resetValidationForYItem(masterY);
                if (selectedVal === constants.PARENT_FORM_VALIDATE.HIERARCHY) {
                    masterY.validation_item_id = constants.PARENT_FORM_VALIDATE.AUTO;
                }
            }

            // nếu follower đang giữ form khác master thì reset về null
            this.input_data.y_items.forEach((y, idx) => {
                if (Number(idx) === Number(yItemIndex) || !y) return;
                if (y.validation_form_id !== null && y.validation_form_id !== this.validationMasterFormId) {
                    y.validation_form_id = null;
                    this.resetValidationForYItem(y);
                }
            });

            this.$nextTick(() => this.$forceUpdate());
        },
        onValidationItemChange(yItemIndex, operatorIndex = 0) {
            // Only process when the first operator changes
            if (operatorIndex !== 0) {
                return;
            }

            const yItem = this.input_data.y_items?.[yItemIndex];
            if (!yItem) return;

            const masterSet = this.validationMasterYIndex !== null && this.validationMasterYIndex !== undefined;
            const isMasterRow = masterSet ? (Number(yItemIndex) === Number(this.validationMasterYIndex)) : true;

            // Master chọn validation_item_id thì các Y khác bị disable và lấy giá trị của master
            if (isMasterRow) {
                const selectedVal = yItem.validation_item_id ?? null;
                this.validationMasterItemId = selectedVal;

                this.input_data.y_items.forEach((row, idx) => {
                    if (!row) return;
                    if (Number(idx) !== Number(yItemIndex)) {
                        // Chỉ fill item theo master cho những Y follower đã chọn form
                        row.validation_item_id = row.validation_form_id ? selectedVal : null;
                    }
                    // Đổi item tham chiếu sẽ reset refs/operator cho từng trục Y khác
                    this.resetValidationOperatorsForYItem(row);
                });

                this.$nextTick(() => this.$forceUpdate());
                return;
            }

            // đổi item khi master chưa chọn item => chỉ reset operator của chính Y đó
            this.resetValidationOperatorsForYItem(yItem);

            this.$nextTick(() => this.$forceUpdate());
        },
        addValidationOperator(yItemIndex) {
            // Add a new validation operator
            const yItem = this.input_data.y_items[yItemIndex];
            if (yItem && yItem.validation_operator) {
                const defaultYKey = yItem.field_key;
                yItem.validation_operator.push({
                    x_key_ref: null,
                    y_key_ref: null,
                    x_key: null,
                    y_key: yItem.validation_form_id ? defaultYKey : null,
                    operator: null
                });
            }
        },
        removeValidationOperator(yItemIndex, operatorIndex) {
            // Remove a validation operator
            const yItem = this.input_data.y_items[yItemIndex];
            if (yItem && yItem.validation_operator && yItem.validation_operator.length > 1) {
                yItem.validation_operator.splice(operatorIndex, 1);
            }
        },
        getFormItemsForValidation(yItemIndex) {
            const yItem = this.input_data.y_items[yItemIndex];
            if (!yItem || !yItem.validation_form_id) {
                return [];
            }
            
            if (!this.validationFormBaseList || !Array.isArray(this.validationFormBaseList)) {
                return [];
            }
            
            const selectedForm = this.validationFormBaseList.find(form => form.form_id === yItem.validation_form_id);
            if (!selectedForm || !selectedForm.form_items || !Array.isArray(selectedForm.form_items)) {
                return [];
            }
            
            // Only get items with input_method = TABLE (10)
            return selectedForm.form_items.filter(item => {
                // Exclude items with special_processing = 1, 2, 3, or 4
                if ([1, 2, 3, 4].includes(item.special_processing)) {
                    return false;
                }
                
                // Only get items with input_method = TABLE
                return item.input_method === InputMethods.INPUT_METHOD_TABLE;
            });
        },
        getValidationOperators(yItem) {
            //  If input_method is 1, 2, 3, 4,7 and check_method contains 3, show all 6 operators
            if (yItem && 
                [1, 2, 3, 4].includes(yItem.input_method) && 
                yItem.check_method && 
                Array.isArray(yItem.check_method) && 
                yItem.check_method.includes(3)) {
                    return this.listValidationOperator;
            }
            else if(yItem.input_method === 7){
                return this.listValidationOperator;
            }
            // Other cases show only 2 operators: = and ≠
            return [
                { label: '=', value: 1 },
                { label: '≠', value: 2 }
            ];
        },
        getTableNameForValidation(yItemIndex) {
            const yItem = this.input_data.y_items[yItemIndex];
            if (!yItem || !yItem.validation_item_id || !yItem.validation_form_id) {
                return '';
            }
            
            if (!this.validationFormBaseList || !Array.isArray(this.validationFormBaseList)) {
                return '';
            }
            
            // Find form in validationFormBaseList with form_id = validation_form_id
            const selectedForm = this.validationFormBaseList.find(form => form.form_id === yItem.validation_form_id);
            if (!selectedForm || !selectedForm.form_items || !Array.isArray(selectedForm.form_items)) {
                return '';
            }
            
            // Find item in form with item_id = validation_item_id
            const selectedItem = selectedForm.form_items.find(item => item.item_id === yItem.validation_item_id);
            if (selectedItem) {
                return selectedItem.label_name || '';
            }
            
            return '';
        },
        getValidationTableYItems(yItemIndex) {
            // Get validation_form_id and validation_item_id from current yItem
            const currentYItem = this.input_data.y_items[yItemIndex];
            if (!currentYItem || !currentYItem.validation_item_id || !currentYItem.validation_form_id) {
                return [];
            }
            
            if (!this.validationFormBaseList || !Array.isArray(this.validationFormBaseList)) {
                return [];
            }
            
            // Find form in validationFormBaseList with form_id = validation_form_id
            const selectedForm = this.validationFormBaseList.find(form => form.form_id === currentYItem.validation_form_id);
            if (!selectedForm || !selectedForm.form_items || !Array.isArray(selectedForm.form_items)) {
                return [];
            }
            
            // Find item in form (from validationFormBaseList) with item_id = validation_item_id
            const selectedItemFromValidationList = selectedForm.form_items.find(item => item.item_id === currentYItem.validation_item_id);
            if (!selectedItemFromValidationList || !selectedItemFromValidationList.input_table) {
                return [];
            }
            
            // Parse input_table if it is a string JSON
            let inputTableData = selectedItemFromValidationList.input_table;
            if (typeof inputTableData === 'string') {
                try {
                    inputTableData = JSON.parse(inputTableData);
                } catch (e) {
                    return [];
                }
            }
            
            // Check and get y_items from input_table
            if (!inputTableData || !inputTableData.y_items || !Array.isArray(inputTableData.y_items)) {
                return [];
            }
            
            // Get check_method and input_method from current yItem to compare
            const currentCheckMethod = Array.isArray(currentYItem.check_method) ? currentYItem.check_method : [];
            const currentInputMethod = currentYItem.input_method;
            
            // Filter y_items by check_method and input_method
            const filteredYItems = inputTableData.y_items.filter(tableYItem => {
                // Get check_method from tableYItem
                const tableYItemCheckMethod = Array.isArray(tableYItem.check_method) ? tableYItem.check_method : [];

                // Check if check_method arrays are the same (same values, order doesn't matter)
                const arraysEqual = (arr1, arr2) => {
                    if (arr1.length !== arr2.length) return false;
                    const sorted1 = [...arr1].sort((a, b) => a - b);
                    const sorted2 = [...arr2].sort((a, b) => a - b);
                    return sorted1.every((val, idx) => val === sorted2[idx]);
                };

                // Compare input_method
                if (tableYItem.input_method !== currentInputMethod) {
                    return false;
                }
                // Compare check_method arrays
                return arraysEqual(currentCheckMethod, tableYItemCheckMethod) && tableYItem.input_method === currentInputMethod;
            });
            
            // Get y_items from input_table of the selected item in validationFormBaseList
            return filteredYItems.map(tableYItem => ({
                field_key: tableYItem.field_key,
                label_name: tableYItem.label_name
            }));
        },
        getValidationTableXItems(yItemIndex) {
            // Get validation_form_id and validation_item_id from current yItem
            const currentYItem = this.input_data.y_items[yItemIndex];
            if (!currentYItem || !currentYItem.validation_item_id || !currentYItem.validation_form_id) {
                return [];
            }
            
            if (!this.validationFormBaseList || !Array.isArray(this.validationFormBaseList)) {
                return [];
            }
            
            // Find form in validationFormBaseList with form_id = validation_form_id
            const selectedForm = this.validationFormBaseList.find(form => form.form_id === currentYItem.validation_form_id);
            if (!selectedForm || !selectedForm.form_items || !Array.isArray(selectedForm.form_items)) {
                return [];
            }
            
            // Find item in form (from validationFormBaseList) with item_id = validation_item_id
            const selectedItemFromValidationList = selectedForm.form_items.find(item => item.item_id === currentYItem.validation_item_id);
            if (!selectedItemFromValidationList || !selectedItemFromValidationList.input_table) {
                return [];
            }
            
            // Parse input_table if it is a string JSON
            let inputTableData = selectedItemFromValidationList.input_table;
            if (typeof inputTableData === 'string') {
                try {
                    inputTableData = JSON.parse(inputTableData);
                } catch (e) {
                    return [];
                }
            }
            
            // Check and get x_items from input_table
            if (!inputTableData || !inputTableData.x_items || !Array.isArray(inputTableData.x_items)) {
                return [];
            }
            
            // Get x_items from input_table of the selected item in validationFormBaseList
            return inputTableData.x_items.map(tableXItem => ({
                field_key: tableXItem.field_key,
                label_name: tableXItem.label_name
            }));
        },
        hasXItemWithLabelName() {
            // Check if there is any x_item with label_name
            if (!this.input_data.x_items || !Array.isArray(this.input_data.x_items)) {
                return false;
            }
            return this.input_data.x_items.some(xItem => xItem.label_name && xItem.label_name.trim() !== '');
        },
        isFirstYItemWithValidation(yItemIndex) {
            // Check if there is any Y item that already has validation_form_id and validation_item_id
            const hasAnyValidation = this.input_data.y_items.some(item => 
                item.validation_form_id && item.validation_item_id
            );
            
            // If no Y item has validation yet, enable all Y items (especially the first one)
            if (!hasAnyValidation) {
                return true;
            }
            
            // If there is already a Y item with validation, find the first one
            const firstYItemWithValidation = this.input_data.y_items.findIndex(item => 
                item.validation_form_id && item.validation_item_id
            );
            
            // Only enable the first Y item that has validation, disable all others
            return firstYItemWithValidation === yItemIndex;
        },
        getTableValidationError(yItemIndex, operatorIndex) {
            // Check errors from props (set by parent when submit)
            if (!this.errors || !Array.isArray(this.errors[yItemIndex])) {
                return null;
            }

            // Show error for first operator (validation_item_id or general errors)
            if (operatorIndex === 0 && this.errors[yItemIndex][0]) {
                const msg = this.errors[yItemIndex][0];
                return (typeof msg === 'string') ? msg : null;
            }

            // Show specific operator error
            if (this.errors[yItemIndex][operatorIndex]) {
                const msg = this.errors[yItemIndex][operatorIndex];
                return (typeof msg === 'string') ? msg : null;
            }

            return null;
        },
    },
    watch:{
        input_data : {
            handler(newValue) {
                this.$emit('input', newValue)
            },
            deep: true,
        },
        // Watch for changes in parent field's special_processing
        'field.special_processing': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.updateItemRolesBasedOnSpecialProcessing()
                }
            },
            immediate: false
        },
        'field.item_role': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.updateItemRolesBasedOnSpecialProcessing()
                }
            },
        }
    }
}
</script>

<style lang="scss">
.table-copy-y-field {
    .el-form-item__content {
        min-width: 280px;
    }
}

.table-copy-y-select {
    width: 100%;
    min-width: 280px;

    .el-input {
        min-width: 280px;
    }

    .el-input__inner {
        min-width: 280px;
    }
}

.input-tables {
    .el-select {
        width: 100%;
    }
}
.transition-box {
    &.input-tables {
        color: #606266 !important;
    }

    .el-form-item.required .el-form-item__label::after {
        content: "*";
        color: red;
    }
}

.y_axis_separation {
    display: block;
    margin-bottom: 30px;

    &::before {
        width: 50%;
        margin-left: 25%;
        height: 5px;
        border-bottom: 2px solid #EBEDF3;
        content: "  ";
        display: block;
    }
}

.axis-target-inline {
    font-weight: bold;
    font-style: normal;
    display: inline-block;
    margin: 0 2px;
    color: #606266;
}

.input_table__label {
    color: #606266;
}

.y_axis,
.x_axis {
    .el-form-item__label {
        position: relative;

        &::before {
            content: "Y";
            position: relative;
            top: -1px;
            margin-right: 2px;
            font-weight: bold;
        }
    }

    &.item-center .el-form-item__label {
        text-align: center;
    }
}

.x_axis {
    .el-form-item__label{
        &::before {
            content: "X";
        }

        &::after {
            content: "*";
            color: red;
        }
    }
}

.axis_plus {
    text-align: left;
    margin-bottom: 15px;
    margin-left: 200px;
    button {
        background-color: #00aff0;
        padding: 5px 15px;
        color: var(--white);
        font-size: 1.2rem;
        i {
            color: var(--white);
            font-size: 1.5rem;
        }
        &:hover {
            background-color: var(--primary);
            color: var(--white);
        }

        &:disabled {
            cursor: unset;
            background-color: rgba(9, 30, 66, 0.48)
        }
        
    }
}
.x_items {
    .el-form-item__content {
        display: flex;
        .remove-x-column {
            margin-left: 4px;
            
        }
    }

    .x_axis_plus {
        text-align: left;
        margin-left: 200px;

        button {
            background-color: #00aff0;
            padding: 5px 15px;
            color: var(--white);
            i {
                color: var(--white);
            }
            &:hover {
                background-color: var(--primary);
            }

            &:disabled {
                cursor: unset;
                background-color: rgba(9, 30, 66, 0.48)
            }
            
        }
        
    }

    .el-form-item.is-required .el-form-item__label {
        &::after {
            content: "*";
            color: red;
        }

        &::before {
            content: "";
        }
    }
}
.file-select {
    display: none;
}

@media only screen and (max-width: 992px){
   .x_items {
        .el-form-item__content {
            width: 100%;
            display: inline-flex;
        }
        .item-error {
            .el-form-item__content {
                display: block;
                text-align: left;
            }
            .el-form-item__label {width: 100%;}

        }
   }
}
</style>